import React, { useContext, useEffect, useState } from "react";
import { Location, useLocation, useNavigate } from "react-router-dom";
import { CreateChannelContext } from "../../context/CreateChannelContext";
import { ChannelState, getChannelStatusString } from "../../models/SKChannel";
import { Link } from "react-router-dom";

interface ChannelEditNavigatorProps {
  title?: string;
  chanelStatus?: ChannelState;
  docId: string;
}

export default function ChannelEditNavigator({ title, chanelStatus, docId }: ChannelEditNavigatorProps) {
  const [imgSrc, setImgSrc] = useState<string>("/icons/Addsign.png");
  const navigate = useNavigate();
  //const location = useLocation();

  // useEffect(() => {
  //   if (channelData.status === ChannelState.DRAFT) {
  //     setEditable(true);
  //   } else {
  //     setEditable(false);
  //   }
  //   if (channelData.status) {
  //     setImgSrc(editable ? "/icons/CheckItem.png" : "/icons/checkeditem.png");
  //   }
  // }, [docId, editable]);

  return (
    <div className="relative w-full min-w-[200px] ">
      <div className="flex items-center pb-[10px]">
        <span className="content_title">{title}</span>
      </div>
      <Link id="content-item" to={`channelEditsDetail`}>
        <div id="content-item" className="input-content-topic !bg-[#FFCC00]">
          <div className="flex items-center justify-between w-full cursor-pointer">
            <div id="topic" className="flex input-content-topic-text">
              View Edits
            </div>

            <div id="title" className="flex m-[15px]">
              <div className="h-[21px] text-right font-roboto font-normal text-[16px] leading-[130%] tracking-[0.36px]">Edits in Review</div>
              {/* <span className="input-plus-topic ml-[5px]">
              <img
                src={imgSrc}
                className="object-contain w-[19px] h-[20px] min-w-5"
                alt="Certification status"
              />
            </span> */}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
